<template>
    <div>
        <p class="title is-5">Bonus coupons</p>
        <p class="title help is-6">
            To fully setting the bonus, configure in the 
            <router-link :to="{ name: 'client-settings-coupon-bonus'}" target="_blank">client settings</router-link> 
            <span class="has-text-danger">(client setting == branch setting)</span>
        </p>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="bonus.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import branchService from '../../../../../../services/branch.service';

import CurrencyInput from '../../../../../common/currency-input.vue';

export default {
    name: 'branch-settings-coupon-bonus',
    components: { CurrencyInput },
    data() {
        return {
            branch: null,
            bonus: {}
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        branchName() {
            return this.$route.params.branch;
        }
    },
    watch: {
        clientId() {
            this.load();
        }
    },
    async mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.branch = await branchService.get(this.clientId, this.branchName);
            this.bonus = this.branch.settings.bonuses.coupon;
        },
        async save() {
            this.branch.settings.bonuses.coupon = this.bonus;

            await branchService.saveSettings(this.clientId, this.branch.branch, this.branch.settings);
            this.branch = await branchService.update(this.branch);
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/bonuses/coupon.vue